import { Link } from "react-router-dom";
import React from "react";

const PublisherTitle = ({ title, id }) => {
  return <Link to={"/publisher/item/" + id}>{title}</Link>;
};

export default PublisherTitle;
